import { axiosRequest } from "../axios.config";

const userApi = {
  getProfile: async (params) => {
    const url = "User/Get-User";
    const response = await axiosRequest.get(url, { params });
    return response;
  },
  updateProfile: async (params) => {
    const url = "User/Update-User";
    const response = await axiosRequest.put(url, params);
    return response;
  },
  changePassword: async (params) => {
    const url = "User/Change-Password";
    const response = await axiosRequest.put(url, params);
    return response;
  },
  getPopularInstructor: async (params) => {
    const url = "User/Get-Popular-Instructor";
    const response = await axiosRequest.get(url, { params });
    return response;
  },
  getAllUsers: async (params) => {
    const url = "Manager/get-all-user-by-role";
    const response = await axiosRequest.get(url, { params });
    return response;
  },
  updateUserActive: async (data) => {
    const url = "Manager/update-active";
    const response = await axiosRequest.put(url, data);
    return response;
  },
};

export { userApi };
